import { faCheck, faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Component } from "react";
import DataTable from "react-data-table-component";
import { formatoSeparadorMilesValue} from "../../generico/utils/FormatoInput";

export default class PrestamoPreaprobadoConfirmar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mensajeModal: "",
    };
  }
  componentDidMount() {}
  handleClickConfirmar = () => {
    
    this.props.confirmarBtn();
    this.modalControl.click();
  };
  handleClickRechazar = () => {
    this.modalControl.click();
  };  

  render() {
    const columns = [
      {
        name: "concepto",
        selector: row => row.concepto,
      },
      {
        name: "valor",
        selector: row => row.valor,
      },
    ];
    return (
      <div className="modal fade" id={this.props.idModal}>
        <div className="modal-dialog  modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                <FontAwesomeIcon icon={faCheck} aria-hidden="true" />{" "}
                {this.props.title}
              </h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">    
              <div className="row">
                <div className="col-12">
                  <div>
                    <section className="content">
                      <div className="container-fluid">                           
                            <div className="row invoice-info">
                              <div className="col-12">
                                <DataTable
                                  columns={columns}
                                  data={this.props.items}
                                  noHeader={true}
                                  customStyles={{rows: {style: {minHeight: '30px'}}}}
                                  getTheadGroupProps ={() => { return { style: { display: "none" } }; }}
                                  noTableHead={true}
                                />
                              </div>
                            </div>
                            {/*Mensaje de morisidad por aporte y solidaridad*/}
                            {this.props.itemsMora.length>0 && (   
                              <div className="row socio-mora-pendiente">
                                <div className="col-12">
                                    <h5>Atención</h5>
                                    <span>
                                      Para cumplir con la relación de aporte/crédito y la 
                                      responsabilidad de estar al día con tus obligaciones societarias, 
                                      el monto que se le descontará de su crédito será de {formatoSeparadorMilesValue(this.props.moraCompromisoTotal)} {this.props.moneda}
                                    </span>
                                    <DataTable
                                      columns={columns}
                                      data={this.props.itemsMora}
                                      noHeader={true}
                                      customStyles={{rows: {style: {minHeight: '30px'}}}}
                                      getTheadGroupProps ={() => { return { style: { display: "none" } }; }}
                                      noTableHead={true}
                                    />
                                    <hr/>
                                    <span style={{fontWeight: 500, float:"right"}}>
                                      El monto Neto a Desembolsar será de {formatoSeparadorMilesValue(this.props.totalDesembolso)} {this.props.moneda}
                                    </span>
                                </div>
                              </div>
                            )}  
                            <hr/>
                            <div className="row invoice-info">
                              <div className="col-12">
                                <div className="row">
                                  <div className="col-lg-6 col-md-4">
                                    <p>Esta seguro que desea CONFIRMAR la operación?</p>
                                  </div>
                                  <div className="col-lg-3 col-md-4">
                                    <button onClick={this.handleClickConfirmar}
                                      type="button"className="btn btn-cu-primary btn-consulta">
                                      <FontAwesomeIcon icon={faCheck} /> Confirmar
                                    </button>
                                    
                                  </div>
                                  <div className="col-lg-3 col-md-4">
                                  <button onClick={this.handleClickRechazar}
                                      type="button" className="btn btn-cu-quintary">
                                     <FontAwesomeIcon icon={faClose} /> Cerrar
                                    </button>                                      
                                    <button ref={(a) => (this.modalControl = a)}
                                      hidden type="button" className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true"> CERRAR</span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
            {/* /.modal-content */}
          </div>
          {/* /.modal-dialog */}
        </div>
      </div>
    );
  }
}
